export default __webpack_public_path__ + "static/media/cross.aeec27d3.png";